module.exports = __webpack_public_path__ + "img/category-mep.cce509ec.svg";